<template>
  <v-card :loading="loading" class="mb-4">
    <v-system-bar> Kurse </v-system-bar>
    <v-list>
      <v-list-item v-for="course in courses" :key="course.id">
        <v-list-item-content>
          <v-list-item-title>{{ course.description }} </v-list-item-title>
          <v-list-item-subtitle>
            {{ course.lessons }} Lektionen
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <CourseLessons
            :disabled="disabled"
            @update="fetchData"
            :value="course"
            :wishId="wishId"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import { defineComponent } from "vue";
import CourseLessons from "./CourseLessons.vue";

export default defineComponent({
  components: { CourseLessons },
  props: {
    wishId: {
      type: Number,
      required: true,
    },
    coursesAvailable: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  name: "CourseWishes",

  data() {
    return { courseWishes: [], loading: false };
  },

  computed: {
    courses() {
      return this.coursesAvailable.map((course) => {
        return {
          ...course,
          description:
            course.subject.description +
            (course.schoolClasses.length == 0
              ? " " + course.grade.description
              : " ") +
            course.schoolClasses.map((c) => c.code).join(", "),
          wish: this.courseWishes.find((c) => c.courseId === course.id) || {
            id: 0,
            lessons: 0,
            comment: null,
          },
        };
      });
    },
  },
  watch: {
    wishId() {
      this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      this.courseWishes = await this.apiList({
        resource: "teacher/wishcourse",
        query: "wish=" + this.wishId,
      });
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
